export var SOCIAL_MEDIA_PLATFORM;
(function (SOCIAL_MEDIA_PLATFORM) {
    SOCIAL_MEDIA_PLATFORM[SOCIAL_MEDIA_PLATFORM["IG"] = 1] = "IG";
    SOCIAL_MEDIA_PLATFORM[SOCIAL_MEDIA_PLATFORM["FB"] = 2] = "FB";
    SOCIAL_MEDIA_PLATFORM[SOCIAL_MEDIA_PLATFORM["TIKTOK"] = 3] = "TIKTOK";
    SOCIAL_MEDIA_PLATFORM[SOCIAL_MEDIA_PLATFORM["TWITTER"] = 4] = "TWITTER";
    SOCIAL_MEDIA_PLATFORM[SOCIAL_MEDIA_PLATFORM["YOUTUBE"] = 5] = "YOUTUBE";
    SOCIAL_MEDIA_PLATFORM[SOCIAL_MEDIA_PLATFORM["OTHERS"] = 99] = "OTHERS";
})(SOCIAL_MEDIA_PLATFORM || (SOCIAL_MEDIA_PLATFORM = {}));
export var EXCLUDED_PROFILING_SOCIAL_MEDIA_PLATFORM = [SOCIAL_MEDIA_PLATFORM.OTHERS, SOCIAL_MEDIA_PLATFORM.YOUTUBE];
